<template>
    <multiselect :disabled="this.disabled" v-model="valueSelected" :options="towns" track-by="uuid" label="name"
        :multiple="false" :allowEmpty="false" placeholder="Municipio" selectedLabel="" selectLabel="" deselectLabel=""
        @select="notifyChange"></multiselect>
</template>
<script>

import Multiselect from "vue-multiselect";
import { getTowns } from "../../api/location-api";

export default {
    name: "NewLocationTownSelector",
    components: {
        Multiselect,
    },

    props: {
        townSelected: Object,
        provinceSelected: Object,
        initialTown: String,
        disabled: Boolean,
        onSelected: Function,
        onFieldClear: Function,
        fieldClearArray: Array,
    },
    data: function () {
        return {
            towns: [],
            valueSelected: null,
        };
    },
    methods: {
        notifyChange: function (value) {
            this.onSelected(value);
            this.onFieldClear([ 'postalCode' ]);
        },

        async getTownList(value) {
            getTowns(value).then(towns => {
                this.towns = towns;

                if (this.townSelected !== null) {
                    let findedTown = this.towns.find(town => town.uuid === this.townSelected.uuid);
                    this.valueSelected = findedTown;
                } else if (this.initialTown !== null) {
                    let findedTown = this.towns.find(province => province.name === this.initialTown);
                    this.valueSelected = findedTown;
                    this.onSelected(findedTown);
                }
            })
        }


    },
    watch: {
        provinceSelected: async function (value) {
            if(value !== null && value !== undefined) {
            await this.getTownList(value.uuid);
            }
        },

        fieldClearArray: function (value) {
            if (value.includes('town')) {
                this.valueSelected = null;
                this.onSelected(null);
            }
        }

    }
}

</script>
